import { Cradle, StripeClientSecret } from '@solo/app-core';
import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Modal, Flex, Text, Button, PaymentComponent, LoadingComponent } from '@/app/ui';
import { translate } from '@/app/i18n';
import { useCradle } from '@/app/contexts';
import Colors from '@/app/styles/Colors';

interface AddPaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
}

const AddPaymentMethodModal = ({ isOpen, onClose, onSave }: AddPaymentMethodModalProps) => {
  const { paymentBloc } = useCradle<Cradle>();
  const [clientSecret, setClientSecret] = useState<StripeClientSecret>();
  const [stripeElement, setStripeElement] = useState<Stripe | null>();

  async function createPaymentIntent() {
    await paymentBloc.createStripeAccount();
    const apiKey = await paymentBloc.getStripePublicKey();
    const paymentIntentClientSecret: StripeClientSecret =
      await paymentBloc.createStripePaymentMethodIntent();

    const s = await loadStripe(apiKey);
    setStripeElement(s);

    setClientSecret(paymentIntentClientSecret);
  }

  useEffect(() => {
    createPaymentIntent();
  }, []);

  return (
    <Modal isOpen={isOpen} position="center" size="sm">
      <Flex.Container flexDirection="column" style={{ padding: '2rem 3rem' }}>
        <Flex.Container flexDirection="column" className="mb-4">
          <Text.PageTitle>{translate('PROFILE_INFO.ADD_PAYMENT_METHOD')}</Text.PageTitle>
        </Flex.Container>

        {clientSecret && stripeElement ? (
          <Elements stripe={stripeElement} options={{ clientSecret }}>
            <PaymentComponent
              clientSecret={clientSecret}
              savePaymentInfo={() => onSave()}
              backgroundColor={Colors.white}
            />
          </Elements>
        ) : (
          <LoadingComponent />
        )}

        <Flex.Container justifyContent="flex-end">
          <Button $size="lg" $transparent $variant="primary" onClick={onClose}>
            <Text.Span fontWeight={700} style={{ width: '80px' }}>
              {translate('PROFILE_INFO.CANCEL')}
            </Text.Span>
          </Button>
        </Flex.Container>
      </Flex.Container>
    </Modal>
  );
};

export default AddPaymentMethodModal;
